import { useSyncExternalStore } from 'react'

export function useMediaQuery(query: string) {
  const subscribe = (callback: () => void) => {
    if (typeof window === 'undefined') return () => {}
    const media = window.matchMedia(query)
    media.addEventListener('change', callback)
    return () => media.removeEventListener('change', callback)
  }

  const getSnapshot = () =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false

  return useSyncExternalStore(subscribe, getSnapshot, () => false)
}

export function useBreakpoint() {
  return {
    xs: useMediaQuery('(min-width: 480px)'),
    sm: useMediaQuery('(min-width: 640px)'),
    md: useMediaQuery('(min-width: 768px)'),
    lg: useMediaQuery('(min-width: 1024px)'),
    xl: useMediaQuery('(min-width: 1280px)'),
    '2xl': useMediaQuery('(min-width: 1536px)'),
  }
}
